var _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDots = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 34 8"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 4,
  fill: "#202124"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 4,
  r: 4,
  fill: "#202124"
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 4,
  r: 4,
  fill: "#202124"
})));
export default SvgDots;